import * as S from "./InputGroup.style";

interface InputGroupProps {
  children: React.ReactElement;
  direction: "column" | "row";
  gridColumn?: string;
}

export const InputGroup = (props: InputGroupProps) => {
  return (
    <S.InputGroup
      $direction={props.direction ? props.direction : "row"}
      $gridColumn={props.gridColumn && props.gridColumn}
    >
      {props.children}
    </S.InputGroup>
  );
};
